<script lang="ts">
  import { brandStore } from '@/lib/brandStore.svelte';
  import { session, type Vehicle } from '@/lib/session.svelte';
  import { navigateTo } from '@/lib/router';

  const labels = $derived(brandStore.labels);
  const cfg = $derived(brandStore.config);

  let makes = $state<string[]>([]);
  let models = $state<string[]>([]);
  let selectedMake = $state('');
  let selectedModel = $state('');
  let selectedYear = $state('');
  let textQuery = $state('');
  let isLoading = $state(false);

  $effect(() => {
    fetch('/vehicles')
      .then(r => r.json())
      .then((data: { makes?: string[] }) => {
        makes = data.makes ?? [];
      })
      .catch(() => {
        // fallback: keep makes empty, text query only
      });
  });

  function onMakeChange() {
    selectedModel = '';
    fetch('/vehicles?make=' + encodeURIComponent(selectedMake))
      .then(r => r.json())
      .then((data: { models?: string[] }) => {
        models = data.models ?? [];
      });
  }

  function handleContinue() {
    if (selectedMake || selectedModel || selectedYear || textQuery) {
      session.setVehicle({ make: selectedMake, model: selectedModel, year: selectedYear || undefined });
    }
    navigateTo('upload');
  }
</script>

<div id="vehicle-selection" class="screen active">
  <div>
    <h2 style="font-size:20px;font-weight:800;letter-spacing:-0.5px;margin-bottom:20px;">{labels?.vehicleScreenTitle ?? 'Configure seu Veículo'}</h2>

    <div class="form-group">
      <label>{labels?.vehicleMakeLabel ?? 'Marca'}</label>
      <select id="vehicle-make" class="form-select" bind:value={selectedMake} onchange={() => { onMakeChange(); }}>
        <option value="">{labels?.vehicleMakePlaceholder ?? 'Selecione a marca'}</option>
        {#each makes as make}
          <option value={make}>{make}</option>
        {/each}
      </select>
    </div>

    <div class="form-group">
      <label>{labels?.vehicleModelLabel ?? 'Modelo'}</label>
      <select id="vehicle-model" class="form-select" bind:value={selectedModel} disabled={!selectedMake}>
        <option value="">{labels?.vehicleModelPlaceholder ?? 'Selecione o modelo'}</option>
        {#each models as model}
          <option value={model}>{model}</option>
        {/each}
      </select>
    </div>

    <div class="form-group">
      <label>{labels?.vehicleYearLabel ?? 'Ano (opcional)'}</label>
      <input type="number" id="vehicle-year" class="form-input"
        placeholder={labels?.vehicleYearPlaceholder ?? 'Ex: 2019'}
        min="1900" max="2030" bind:value={selectedYear} />
    </div>

    <div class="form-group">
      <label>{labels?.vehicleTextLabel ?? 'Ou pesquise'}</label>
      <input type="text" id="vehicle-text" class="form-input"
        placeholder={labels?.vehicleTextPlaceholder ?? 'Ex: Onix 2019'}
        bind:value={textQuery} />
    </div>

    <button id="btn-continue" class="btn btn-primary" style="width:100%;margin-top:16px;" onclick={handleContinue}>
      {labels?.btnContinue ?? 'Continuar'}
    </button>
    <button id="btn-skip" class="btn btn-secondary" style="width:100%;margin-top:12px;" onclick={() => navigateTo('upload')}>
      {labels?.btnSkip ?? 'Pular esta etapa'}
    </button>
  </div>
</div>
